module.exports = {
	"articleTitle1": "A mixed review of my top three coffee shops ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Espresso Royale",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/star-vintage-profile",
	"articleSnippet1": "Apr 5, 2017 ... Snuggly placed right onto Liberty St., a stone's throw from State. ... maybe more \nthan one of us shares the theory that Espresso Royale is really ...",
	"articleSnippet2": "Mar 21, 2010 ... Sandwiched between Espresso Royale and Noodles and Co. on State Street sits \na lone rack of old sweaters. The glittery sign above it reads ...",
	"foodRecommendations": [
		{
			"text": "If you don’t know the wifi password to Espresso Royale on State Street, do you even go here? The horribly lit location of the Michigan chain has become a mainstay for students, mostly for $2 coffee day and their patience with 20 year olds who buy one drink and sit there on laptops for three to twelve hours. Get the vegan zucchini bread, not a croissant.",
			"peson": "Rebecca Lerner"
		}
	],
	"articleTitle2": "Star Vintage's retail time capsule",
	"address": "322 S State St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170519/aak.BSIDE_.Espresso.4-9-12.0035.jpg?itok=V_WA7Ccs",
			"author": "File Photo",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.278576,
		"lng": -83.741054
	},
	"totalMisc": 1,
	"categories": {
		"coffeeshop": 1,
		"fooddrink": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/espressoroyalestate.json
// module id = 876
// module chunks = 0